import { useMemo } from 'react';

export default function FaqSection() {
  const faqs = useMemo(() => [
    {
      id: 1,
      q: '51暗网吃瓜是什么平台？',
      a: '51暗网吃瓜是一个专注于吃瓜视频在线观看的内容聚合平台。我们整合了51吃瓜在线、51cg吃瓜等多渠道的暗网吃瓜视频资源，为您提供流畅高清的在线暗网吃瓜体验，内容每日更新，覆盖娱乐八卦、社会事件、网络热议等多个领域。',
    },
    {
      id: 2,
      q: '暗网吃瓜直播和普通视频有什么区别？',
      a: '暗网吃瓜直播提供实时追踪的吃瓜内容，主播会即时跟进热点事件的最新进展，让您第一时间了解事态发展。而51吃瓜视频在线则汇集了经过整理的精选内容，更适合回顾和深度了解。两者互为补充，满足不同吃瓜需求。',
    },
    {
      id: 3,
      q: '在51暗网吃瓜浏览安全吗？',
      a: '我们高度重视用户隐私安全。51暗网吃瓜采用匿名化浏览机制，不会记录您的浏览历史和个人信息。所有暗网吃瓜视频的访问均经过加密处理，确保您的在线暗网吃瓜体验安全无忧。建议使用最新版浏览器以获得最佳保护。',
    },
    {
      id: 4,
      q: '如何获取最新的吃瓜视频更新？',
      a: '51暗网吃瓜的内容团队24小时关注热点事件，确保吃瓜视频实时更新。您可以直接访问我们的首页查看最新的51吃瓜在线内容，也可以关注热门话题标签追踪特定事件。所有51cg吃瓜和暗网吃瓜直播内容都会第一时间呈现在首页。',
    },
  ], []);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-3">关于51暗网吃瓜，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-primary-50 flex items-center justify-center shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-primary-500">Q</span>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-500 mt-3 ml-9 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}